// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from "react";
import { DefaultButton } from "office-ui-fabric-react";
import ModalComponent from "../ModalComponent/ModalComponent";

import "./UploadSummaryModal.scss";

const UploadSummaryModal = ({ isVisible, results, onClose, t }) => {
  if (!results) {
    return null;
  }

  const failures = results.results.filter(r => r.status === "failure");

  return (
    <ModalComponent isVisible={isVisible} className="upload-summary-modal">
      <div className="message-container">
        <h2 className="heading-2">Upload Summary</h2>
        <div className="summary-stats">
          <p>Success: {results.successCount}</p>
          <p>Failed: {results.failureCount}</p>
        </div>
        {failures.length > 0 && (
          <div className="failure-details">
            <div className="failure-list">
              {failures.map((f, i) => (
                <div key={i} className="failure-item">
                  <span className="failure-id">ID: {f.id}</span>
                  <span className="failure-message">{f.message}</span>
                </div>
              ))}
            </div>
          </div>
        )}
        <div className="btn-group">
          <DefaultButton className="modal-button close-button" onClick={onClose}>Close</DefaultButton>
        </div>
      </div>
    </ModalComponent>
  );
};

export default UploadSummaryModal;
